<template>
  <div style="margin-top: 20px">
    <CCard>
      <CCardHeader>
        <h5><b>NFT UPlOAD</b></h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="6">
                <CInput placeholder="Enter NFT Name" v-model="name" />
              </CCol>
              <CCol sm="6">
                <CInput placeholder="Enter Network" v-model="network" />
              </CCol>
              <CCol sm="6">
                <CInput placeholder="Enter Company Name" v-model="company" />
              </CCol>

              <CCol sm="6">
                <CInput placeholder="Enter Price" v-model="price" />
              </CCol>
              <CCol sm="6">
                <CInput placeholder="Enter Supply" v-model="supply" />
              </CCol>
              <CCol sm="6">
                <CInput placeholder="Enter Symbol" v-model="symbol" />
              </CCol>
              <CCol sm="6">
                <CInput placeholder="Enter TokenSymbol" v-model="tokenSymbol" />
              </CCol>
              <CCol sm="6">
                <CInput placeholder="Enter Type" v-model="type" />
              </CCol>
              <CCol sm="6">
                <CTextarea
                  label="Description"
                  placeholder="Content..."
                  horizontal
                  rows="4"
                  v-model="description"
                />
              </CCol>
              <CCol sm="6">
                <CRow>
                  <CCol sm="9">
                    <label>Network Image</label>

                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage3"
                          accept="image*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue3.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue3"
                            max="100"
                          ></progress>
                        </p>
                        <CButton
                          color="success"
                          @click="onUpload3()"
                          v-if="uploadbtn3"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData3 != null">
                      <img
                        class="preview"
                        :src="picture3"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                  </CCol>
                </CRow>
              </CCol>
              <CCol sm="6">
                <CRow>
                  <CCol sm="9">
                    <label>Image</label>
                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage"
                          accept="image/*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue"
                            max="100"
                          ></progress>
                        </p>

                        <CButton
                          color="success"
                          @click="onUpload()"
                          v-if="uploadbtn"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData != null">
                      <img
                        class="preview"
                        :src="picture"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                  </CCol>
                </CRow>
              </CCol>
              <CCol sm="6">
                <CRow>
                  <CCol sm="9">
                    <label>Logo</label>

                    <div>
                      <div>
                        <input
                          type="file"
                          @change="previewImage2"
                          accept="image/*"
                        />
                      </div>
                      <div>
                        <p>
                          Progress: {{ uploadValue2.toFixed() + "%" }}
                          <progress
                            id="progress"
                            :value="uploadValue2"
                            max="100"
                          ></progress>
                        </p>
                        <CButton
                          color="success"
                          @click="onUpload2()"
                          v-if="uploadbtn2"
                          >Upload</CButton
                        >
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="3">
                    <div v-if="imageData2 != null">
                      <img
                        class="preview"
                        :src="picture2"
                        style="width: 145px; height: 100px; float: right"
                      />
                      <br />
                    </div>
                  </CCol>
                </CRow>
              </CCol>
              <CCol sm="8">
                <span style="font-size: 14px">Attribute *</span>
                <br />

                <div
                  class="form-group"
                  v-for="(input, k) in this.attribute"
                  :key="k"
                >
                  <CRow>
                    <CCol sm="6">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Trait_type"
                        v-model="input.trait_type"
                      />
                    </CCol>
                    <CCol sm="4">
                      <input
                        type="text"
                        placeholder="value"
                        class="form-control"
                        v-model="input.value"
                      />
                    </CCol>
                    <CCol sm="2">
                      <span>
                        <CButton
                          color="danger"
                          @click="remove(k)"
                          v-show="k || (!k && attribute.length > 1)"
                        >
                          -</CButton
                        >&nbsp;&nbsp;&nbsp;
                        <CButton
                          color="success"
                          @click="add(k)"
                          v-show="k == attribute.length - 1"
                        >
                          +</CButton
                        >
                      </span>
                    </CCol>
                  </CRow>
                </div>
              </CCol>
              <CCol sm="4" style="margin-top: 20px">
                <CButton color="success" @click="getApidata()"
                  >Get IPFS</CButton
                >
              </CCol>
              <CCol sm="12" style="margin-top: 40px">
                <CInput
                  label="IPFS Hash"
                  placeholder="Enter your hash"
                  v-model="this.nftJsonUrl"
                />
              </CCol>
              <CCol sm="12">
                <CInput
                  label="Enter TokenAddress"
                  placeholder="Enter TokenAddress"
                  v-model="tokenAddress"
                />
              </CCol>
              <CCol sm="12">
                <CInput
                  label="ContractAddress"
                  placeholder="Enter ContractAddress"
                  v-model="contractAddress"
                />
              </CCol>
              <CCol sm="12">
                <CInput
                  label="BuyContractAddress"
                  placeholder="Enter BuyContractAddress"
                  v-model="buyContractAddress"
                />
              </CCol>
              <CButton color="success" style="margin: auto"  @click="saveData()">Save</CButton>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import firebase from "firebase";
import buffer from "buffer";
const db = firebase.firestore();
import axios from "axios";
export default {
  data() {
    return {
      attribute: [
        {
          trait_type: "",
          value: "",
        },
      ],
      imageData: null,
      picture: null,
      uploadValue: 0,
      uploadbtn: false,

      imageData2: null,
      picture2: null,
      uploadValue2: 0,
      uploadbtn2: false,

      imageData3: null,
      picture3: null,
      uploadValue3: 0,
      uploadbtn3: false,

      nftJsonUrl: "",
      name: "",
      network: "",
      company: "",
      description: "",
      price: "",
      supply: "",
      symbol: "",
      tokenSymbol: "",
      type: "",
      buyContractAddress: "",
      contractAddress: "",
      tokenAddress: "",
    };
  },
  methods: {
    getApidata() {
      var ipfsAPI = require("ipfs-api");
      var ipfs = ipfsAPI("ipfs.infura.io", "5001", { protocol: "https" });
      let nftInfo = {
        name: this.name,
        description: this.description,
        image: this.picture,
        attributes: this.attribute,
      };

      // Sample Attribute : "attributes":[{"trait_type":"Get Rewarded in $Rage","value":"450"}]
      ipfs.add(new Buffer(JSON.stringify(nftInfo)), async (err, result) => {
        if (err) {
          console.log(err);
        }
        // console.log(result);
        this.nftJsonUrl = "https://gateway.ipfs.io/ipfs/" + result[0].hash;
        console.log("URL", this.nftJsonUrl);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "IPFS Has created Successfully",
          showConfirmButton: false,
          timer: 3000,
        });
      });
    },
    add() {
      this.attribute.push({
        trait_type: "",
        value: "",
      });
      console.log("attribute", this.attribute);
    },

    remove(index) {
      this.attribute.splice(index, 1);
    },

    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn = true;
      // }
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url1", url);
            this.picture = url;
            // this.token.logo = url;
            if (this.picture.length > 0) {
              this.uploadbtn = false;
            }
          });
        }
      );
    },
    previewImage2(event) {
      this.uploadValue2 = 0;
      this.picture2 = null;
      this.imageData2 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn2 = true;
      // }
    },

    onUpload2() {
      this.picture2 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData2.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData2);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue2 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue2 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url2", url);
            this.picture2 = url;
            // this.token.displaylogo = url;
            if (this.picture2.length > 0) {
              this.uploadbtn2 = false;
            }
          });
        }
      );
    },
    previewImage3(event) {
      this.uploadValue3 = 0;
      this.picture3 = null;
      this.imageData3 = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn3 = true;
      // }
    },

    onUpload3() {
      this.picture3 = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData3.name.split(".")[1];
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData3);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue3 =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue3 = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url3", url);
            this.picture3 = url;
            // this.token.capturelogo = url;
            if (this.picture3.length > 0) {
              this.uploadbtn3 = false;
            }
          });
        }
      );
    },

    saveData() {
      db.collection("NFT-Temp")
        .add({
          image: this.picture,
          logo: this.picture2,
          networkimage: this.picture3,
          name: this.name,
          network: this.network,
          company: this.company,
          description: this.description,
          price: this.price,
          supply: this.supply,
          symbol: this.symbol,
          type:this.type,
          tokenSymbol: this.tokenSymbol,
          buyContractAddress: this.buyContractAddress,
          contractAddress: this.contractAddress,
          tokenAddress: this.tokenAddress,
          ipfsURL:this.nftJsonUrl
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 3000,
          });
          //   self.$router.push({ name: "tokenEntry" });
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },
  },
};
</script>